import React from 'react';

import { renderUserInput } from "./DropdownFunctions";

import PropTypes from "prop-types";

const UserInputControlled = (props ) =>
{
    return (
        <div key={props.keyValue} className={props.containerClassName}>
            { renderUserInput(props) }
        </div>
    );
}

export default UserInputControlled;

UserInputControlled.defaultProps =
{
    defaultClassName: 'form-group'
}

UserInputControlled.propTypes = {
    onChange: PropTypes.func.isRequired
};